import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from '@/shared.module';

/**
 * Read-only dialog explaining NANDA-I diagnostics: the PES format (problem,
 * etiology, signs/symptoms), clinical substantiation with sources, and why
 * the diagnosis has priority right now. Opened from the info icon in the
 * diagnosis column; closes without a result.
 */
@Component({
  selector: 'app-nnn-diagnosis-info-dialog',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './nnn-diagnosis-info-dialog.component.html',
  styleUrl: './nnn-diagnosis-info-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NnnDiagnosisInfoDialogComponent {
  protected readonly pesItems = ['problem', 'etiology', 'symptoms'] as const;
}
